import { Fragment, useEffect, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ProfilesCrumbs } from '../constants';
import ProfileForm, { FormProfile } from 'system/components/profiles/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useNavigate, useParams } from 'react-router';
import { HttpResponse } from 'shell/models/http-response';
import { Profile } from 'shell/models/profile';

const ProfilesDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const {
    get: getProfile,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Profile>>(`${__MANAGEMENT_API_URL__}/profili/${params.id}`);

  useEffect(() => {
    getProfile();
  }, []);

  const profile: FormProfile = useMemo(() => {
    const profilePayload = data?.payload;
    if (!profilePayload || !!error) {
      return {};
    }
    return {
      code: profilePayload.key?.codice?.toString() || '',
      name: profilePayload.nome,
      lastUpdate: profilePayload.note,
      functionalities: profilePayload.funzioni?.map((element) => ({
        id: element.key?.codice?.toString(),
        institutionCode: element.codiceEnte,
        description: element.nome,
        entity: element.entita,
        event: element.evento,
        checked: true,
      })),
      groups: profilePayload.gruppi?.map((element) => ({
        id: element.key?.codice?.toString(),
        description: element.nome,
        institutionCode: element.codiceEnte,
        checked: false,
      })),
    };
  }, [data, error]);

  return (
    <Fragment>
      <Breadcrumbs items={[...ProfilesCrumbs, { name: 'Dettaglio Profilo' }]} />
      {!loading && data ? (
        <ProfileForm
          title="Dettaglio Profilo"
          onOk={() => {
            return;
          }}
          onCancel={() => {
            navigate('/sistema/profili');
          }}
          initialValues={profile}
          disabled
        />
      ) : undefined}
    </Fragment>
  );
};

ProfilesDetailPage.displayName = 'Profiles detail page component';

export default ProfilesDetailPage;
